import { useContext } from 'react'
import { useParams } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { Box, Stack } from '@mui/material'
import Page from '../pages/Page'
import MDTypography from '../MDTypography'
import FetchContext from '../../context/fetch/FetchContext'
import FormattedDate from '../table/FormattedDate'
import ReplyBody from './ReplyBody'
import { replyQueryKey } from './repliesQueryKey'
import { NOTHING } from './resolveReplyRows'

function Detail({ label, children }) {
    return (
        <Stack direction="row" spacing={1} alignItems="center">
            <MDTypography variant="button" fontWeight="bold">{label}</MDTypography>
            <MDTypography variant="button">{children}</MDTypography>
        </Stack>
    )
}

function DetailDate({ value }) {
    if (value == null) {
        return <Box component="span">{NOTHING}</Box>
    }

    return <FormattedDate value={value} />
}

export default function ReplyPage() {
    const { replyId } = useParams()
    const fetcher = useContext(FetchContext)

    const {
        data: reply,
        isFetching,
        isLoading,
    } = useQuery({
        queryKey: replyQueryKey(replyId),
        queryFn: () => fetcher.fetchReply(replyId),
    })

    return (
        <Page
            className="reply"
            title="תגובה"
            busy={isFetching || isLoading}
        >
            <Stack spacing={2} p={2}>
                <Stack spacing={0.5}>
                    <Detail label="מודעה">{reply?.announcementTitle ?? NOTHING}</Detail>
                    <Detail label="מאת">{reply?.fromAddress}</Detail>
                    <Detail label="נושא">{reply?.subject}</Detail>
                    <Detail label="תאריך תגובה">
                        <DetailDate value={reply?.receivedAt} />
                    </Detail>
                    <Detail label="תאריך שליחה">
                        <DetailDate value={reply?.sentAt} />
                    </Detail>
                </Stack>
                <ReplyBody body={reply?.body} />
            </Stack>
        </Page>
    )
}
